<template>
  <v-text-field
    class="pt-4 px-3 pb-2 mt-0 mb-3 overlay-options-field-bg"
    :value="value"
    :type="numberFieldInputType"
    :step="stepSize"
    :label="noLabel ? '' : field.data.label"
    :placeholder="field.data.placeholder"
    :append-icon="currencyIcon"
    :required="field.required"
    :rules="field.rules"
    :style="field.data.css ? field.data.css.field : null"
    :disabled="disabled"
    data-cy="overlay-data-pricefield"
    @focus="onInputFocused"
    @input="onPriceChanged"
  />
</template>

<script>
import {transformPriceValueToUseNumberOfDecimals} from '@/utils';

import {getNumDecimals, OverlayOptionsField} from '@/mixins/overlayOptions.js';

export default {
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currencySymbol: {
      type: String,
      default: '€',
    },
  },
  computed: {
    stepSize() {
      const defaultStep = 0.01;
      if (this.field.schema && this.field.schema.multipleOf !== undefined) {
        return this.field.schema.multipleOf; // Usually values like: 1, 0.1, 0.01.
      }
      return defaultStep;
    },
    /**
     * IE11/Edge do not support using a comma separator in number inputs.
     *
     * The only workaround for this is to use type="text" instead.
     * We'll lose the increase/decrease buttons, but all rule
     * validations will still work and german users can use a comma as
     * they are used to.
     */
    numberFieldInputType() {
      if (this.$store.state.common.runtimeEnv.edge) {
        return 'text';
      }
      return 'number';
    },
    /**
     * Use pretty icon if we have one or fallback to the raw char.
     */
    currencyIcon() {
      const symbolToIcon = {
        '€': 'euro_symbol',
        $: 'attach_money',
      };
      const symbol = this.currencySymbol;
      const icon = symbolToIcon[symbol] || symbol;
      return icon;
    },
  },
  mounted() {
    // Ensure price is saved with correct number of decimals, so next
    // time the dialog will show them all the same. Note: Doing this
    // conversion 'live' by wrapping the v-model is very frustrating for
    // the User when typing in values with the cursor jumping around.
    const numDecimals = getNumDecimals(this.field.schema.multipleOf || 0.01);
    const twoDigitValue = transformPriceValueToUseNumberOfDecimals(
      this.value,
      numDecimals
    );
    if (this.value !== twoDigitValue) {
      this.onPriceChanged(twoDigitValue);
    }
  },
  methods: {
    onInputFocused(event) {
      if (this.field && this.field.data && this.field.data.select_on_focus) {
        event.target.select();
      }
    },
    onPriceChanged(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OverlayDataPriceField.vue